// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2YE0U","content":"LoadingAlert_content__28off"};